import React, { useState,useEffect,useCallback ,useMemo,useLayoutEffect,useRef } from 'react';

import ModalAllder from 'components/layout/ModalAllder';
import { nanoid } from 'nanoid'
import Box from '@mui/material/Box';
import Popover from '@mui/material/Popover';
import Typography from '@mui/material/Typography';

import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import Button from '@mui/material/Button';
import AllderTable from 'components/layout/AllderTable';
import Radio from '@mui/material/Radio';

export default function ModalProductHistory({modal,setModal,productID}){


    const [tab, setTab] = useState(1);


    const [data, setData] = useState([]);


    useEffect(() => {
        setData(productList);
    }, []);

    const [filterText, setFilterText] = useState('');

    let filteredItems =  data.filter(
        item => item.documentNumber && item.documentNumber.toLowerCase().includes(filterText.toLowerCase())    
    );

    
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [popid, setPopid] = useState(null);

    
    const [documentSelected, setDocumentSelected] = useState(null);

    const colum = [
        { 
            field: 'id', 
            headerName: '', width: 100,
            sortable: false,
            renderCell: ({ row }) => (

                <Radio
                    checked={documentSelected  == row.id}
                    onChange={(e) => {
                        setDocumentSelected(row.id)
                    }}
                    value={row.id}
                    name="docID"
    
                />

            )
        },
        { 
            field: 'documentNumber', 
            headerName: 'เลขที่ใบขอซื้อ', width: 160,
            sortable: false,
            renderCell: ({ row }) => (<div><div style={{color:'#565DFF'}}>{row.documentNumber}</div></div>)
        },
        {
            field: 'supplierName',
            headerName: 'ชื่อคู่ค้า',
            width: 250,
            sortable: false,
            renderCell: ({ row }) => (<div><div>{row.supplierName}<br/>({row.supplierBranchName})</div></div>)
        },
        {
          field: 'products',
          headerName: 'รายการสินค้า',
          width: 200,
          sortable: false,
          renderCell: ({ row }) => {
            if(row.products.length > 0){
                const handlePopoverOpen = (event) => {
                    setAnchorEl(event.currentTarget);
                };
            
                const handlePopoverClose = () => {
                    setAnchorEl(null);
                };
                return (
                    <div>
                        <Typography
                            aria-owns={open ? 'mouse-over-popover' : undefined}
                            aria-haspopup="true"
                            onMouseEnter={(event) => {
                                setAnchorEl(event.currentTarget);
                                setPopid(row.id)
                            }}
                            onMouseLeave={(event) => {
                                setAnchorEl(null);
                                setPopid(null)
                            }}
                        >
                            <span>{row.products[0]}</span>
                            {
                            row.products.length > 1 ? (
                            <span> และอีก {row.products.length-1} รายการ </span>
                            ) : ''
                            }
                        </Typography>
                        <Popover
                            id="mouse-over-popover"
                            sx={{
                                pointerEvents: 'none',
                            }}
                            open={popid == row.id}
                            anchorEl={anchorEl}
                            anchorOrigin={{
                            vertical: 'bottom',
                            horizontal: 'left',
                            }}
                            transformOrigin={{
                            vertical: 'top',
                            horizontal: 'left',
                            }}
                            onClose={handlePopoverClose}
                            disableRestoreFocus
                        >
                            <Typography sx={{ p: 1 }}>
                                {row.products.map((item, index) => (
                                    <div key={index}>{item}</div>
                                ))}
                            </Typography>
                        </Popover>
                    </div>
                )
            }

            return ''
          }
        },
        {
          field: 'productQty',
          headerName: 'จำนวน',
          width: 110,
          sortable: false,
        },
        {
          field: 'deliveryDate',
          headerName: 'วันที่ส่งมอบ',
          sortable: false,
          width: 160,
        },
        {
          field: 'netValue',
          headerName: 'ยอดรวม',
          width: 110,
          sortable: false,
        },
        {
          field: 'status',
          headerName: 'สถานะ',
          width: 150,
          sortable: false,
          renderCell: ({ row }) => (
                
            row.status == 1 ? 
                <div
                    className="px-3 py-1 mx-auto"
                    style={{
                        color: "#FDB428",
                        backgroundColor: "rgba(255, 246, 229, 1)",
                        borderRadius: "20px",
                    }}
                >
                    รออนุมัติ
                </div> 
            : row.status == 2 ? 
                <div
                    className="px-3 py-1 mx-auto"
                    style={{
                        color: "#FF731D",
                        backgroundColor: "rgba(255, 115, 29, 0.15)",
                        borderRadius: "20px",
                    }}
                >
                    กำลังดำเนินการ
                </div> 
            : row.status == 3 ? 
                <div
                    className="px-3 py-1 mx-auto"
                    style={{
                        color: "rgba(114, 225, 40, 0.87)",
                        backgroundColor: "rgba(238, 251, 229, 1)",
                        borderRadius: "20px",
                    }}
                >
                    เสร็จสิ้น
                </div> 
            : row.status == 0 ? 
                <div
                    className="px-3 py-1 mx-auto"
                    style={{
                        color: "#747474",
                        backgroundColor: "#F4F4F4",
                        borderRadius: "20px",
                    }}
                >
                    แบบร่าง
                </div> 
            : row.status == 4 ? 
                <div
                    className="px-3 py-1 mx-auto"
                    style={{
                        color: "rgba(249, 80, 87, 1)",
                        backgroundColor: "rgba(255, 0, 0, 0.15)",
                        borderRadius: "20px",
                    }}
                >
                    ยกเลิก
                </div> 
        :    ''
                
            
        )
        }
    ];



    const open = Boolean(anchorEl);

    return (
        <>
        <ModalAllder  
            modal={modal} 
            setModal={setModal}  
            htitle={"โหลดเอกสาร"} 
            hbtn={true}
        >
            
            <div className='my-7'>
                <Button variant={`${tab == 1 ? 'contained' : ''}`} color='primary' onClick={() => {
    
                    setTab(1)
                }}>ประวัติการซื้อสินค้า</Button>
        
                <Button variant={`${tab == 2 ? 'contained' : ''}`} color='primary'  onClick={() => {
        
                    setTab(2)
                    
                }}>ประวัติการขายสินค้า</Button>
            </div>

            

            {
                tab == 1 ? (
                    <>
                        <div>
                            <AllderTable
                                getRowId={(row) => row.id}
                                getRowHeight={() => 'auto'}
                                autoHeight={true}
                                rows={filteredItems}
                                columns={colum}
                                
                                initialState={{
                                    pagination: {
                                        paginationModel: {
                                            pageSize: 5,
                                        },
                                    },
                                }}
                                pageSizeOptions={[5,10,15]}
                                checkboxSelection={false}
                                disableRowSelectionOnClick
                                slotProps={{ pagination: { labelRowsPerPage: 'จำนวนรายการต่อหน้า' } }}
                            />
                        </div>


                        <div className='text-right mt-7'>

                            <Button variant="contained" color='primary'  className='!px-10 !mr-4' 
                                disabled={!documentSelected}
                                onClick={() => {
                                    setModal( (prev) => ({...prev,open:false}) )
                                }}
                            >ยืนยัน</Button>
                            <Button variant="outlined" color='gray'  className='!px-10 '  onClick={() => {
                                setModal( (prev) => ({...prev,open:false}) )
                            }}>ยกเลิก</Button>
                        </div>
                    </>
                ) : (
                    <div className="d-flex justify-content-center">
                        <table className="table table-bordered text-center max-w-[600px]">
                            <thead className="">
                                <tr style={{height:'50px'}}>
                                    <th className="bg-[#F5F5F7]" >เดือน</th>
                                    <th className="bg-[#F5F5F7]">จำนวนขายรวมทุกสาขา (ชิ้น)</th>
                                    <th className="bg-[#F5F5F7]">อัตราเติบโต</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr style={{height:'50px'}}>
                                    <td valign="middle">มกราคม</td>
                                    <td valign="middle">5,000</td>
                                    <td valign="middle">0 %</td>
                                </tr>
                                <tr style={{height:'50px'}}>
                                    <td valign="middle">กุมภาพันธ์</td>
                                    <td valign="middle">5,000</td>
                                    <td valign="middle" ><div className="text-[#2DC76D]">10 %</div></td>
                                </tr>
                                <tr style={{height:'50px'}}>
                                    <td valign="middle">มีนาคม</td>
                                    <td valign="middle">5,000</td>
                                    <td valign="middle" ><div className="text-[#FF0000]">-10 %</div></td>
                                </tr>
                                <tr style={{height:'50px'}}>
                                    <td valign="middle">เมษายน</td>
                                    <td valign="middle">5,000</td>
                                    <td valign="middle">0 %</td>
                                </tr>
                                <tr style={{height:'50px'}}>
                                    <td valign="middle">กุมภาพันธ์</td>
                                    <td valign="middle">5,000</td>
                                    <td valign="middle" ><div className="text-[#2DC76D]">10 %</div></td>
                                </tr>
                                <tr style={{height:'50px'}}>
                                    <td valign="middle">มีนาคม</td>
                                    <td valign="middle">5,000</td>
                                    <td valign="middle" ><div className="text-[#FF0000]">-10 %</div></td>
                                </tr>
                            </tbody>
                        </table>

                    </div>
                )
            }

            
        </ModalAllder>
        </>
    )
}


const productList = [
    {
        "id": 1,
        "documentNumber": "PR-202304050001",
        "supplierName": "บริษัท เอนเทอร์ อีเอสซี จำกัด",
        "supplierBranchName": "สำนักงานใหญ่",
        "products":['น้ำตาลทรายขาว 1 KG','น้ำตาลทรายแดง 1 KG','น้ำตาลทรายเขียว 1 KG'],
        "deliveryDate":"02/11/2023",
        "productQty":40,
        "netValue":"3,440.00",
        "status":2
    },
    {
        "id": 56,
        "documentNumber": "PR-202304050001",
        "supplierName": "บริษัท เอนเทอร์ อีเอสซี จำกัด",
        "supplierBranchName": "สำนักงานใหญ่",
        "deliveryDate":"02/11/2023",
        "products":['น้ำตาลทรายขาว 1 KG','น้ำตาลทรายขาว 1 KG','น้ำตาลทรายขาว 1 KG','น้ำตาลทรายขาว 1 KG','น้ำตาลทรายขาว 1 KG'],
        "productQty":40,
        "netValue":"3,440.00",
        "status":2
    }
]